import { Label } from './common/label'
import { useForm } from './form'

export const FormSimpleSelectStr = ({ name, label, items, defaultValue, required, hidden, readonly, disabled }) => {
  const { register } = useForm(name, { required, defaultValue, shouldDirty: true })

  return (
    <Label name={name} label={label} required={required} hidden={hidden}>
      <select className={`form-control ${readonly && 'bg-secondary-subtle'}`} {...register()} readOnly={readonly} disabled={disabled}>
        <option value={''}>Select</option>
        {items &&
          items.map((item, i) =>
            <option key={i}>
              {item}
            </option>
          )}
      </select>
    </Label>
  )
}
